/* eslint-disable */

import { toCurrency } from '../../utils/CurrencyUtil'
import ActionPlanPlanCards from './ActionPlanPlanCards'
import ActionPlanBottomBar from './ActionPlanBottomBar'

const Plans = ({
  adminPlans,
  totalLumpsum,
  totalSip,
  isAllSelected,
  setIsAllSelected,
  selectedPlans,
  openPlans,
  handleCheckboxChange,
  togglePlan,
  onOpen,
  isDesktop,
  flowStep,
  sipDate,
  sipDates,
  selectedDay,
  setSelectedDay,
  mandatesState,
  mandates,
  disableButtons,
  mandateRegistration,
  generateOTP,
  loading,
  setMessageModalState,
  openOTPPopup,
  setOpenOTPPopup,
  userDetails,
  email,
  handleSipOrOT,
}) => {
  return (
    <div className='mx-4 mt-3 md:mx-auto md:max-w-[760px] lg:max-w-[1128px]'>
      <div>
        <h1 className='mt-4 flex items-center justify-between'>
          <span className='font-IBM text-xl font-bold text-black-950 md:text-2xl'>
            Your Plans ({adminPlans?.length})
          </span>
        </h1>
        <p className='mt-1 font-DMSans text-sm font-normal text-black-500 md:text-base'>
          Plans have been curated as per your needs
        </p>
      </div>

      <div className='my-4 grid grid-cols-1 gap-3 min-[380px]:grid-cols-2 lg:gap-4'>
        <div className='fabits-card flex-1 p-3 md:p-5'>
          <h1 className='fabits-eyebrow'>One time Investment</h1>
          <p className='mt-3 flex h-[32px] items-end font-normal text-xl leading-none text-black-950 md:h-[36px] md:text-3xl'>
            <span className='mr-1.5 flex items-end font-DMSans text-lg font-extrabold md:mr-2 md:text-[1.6rem]'>
              ₹
            </span>
            <span className='font-IBM font-bold'>{toCurrency(totalLumpsum)}</span>
          </p>
        </div>

        <div className='fabits-card flex-1 p-3 md:p-5'>
          <h1 className='fabits-eyebrow'>SIP (Excluding active SIPs)</h1>
          <p className='mt-3 flex h-[32px] items-end font-normal text-xl leading-none text-black-950 md:h-[36px] md:text-3xl'>
            <span className='mr-1.5 flex items-end font-DMSans text-lg font-extrabold md:mr-2 md:text-[1.6rem]'>
              ₹
            </span>
            <span className='font-IBM font-bold'>{toCurrency(totalSip)}</span>
          </p>
        </div>
      </div>

      <div className='mb-3 flex items-center justify-between text-sm'>
        <p className='font-medium text-black-700'>Select a plan to proceed</p>
        <span
          className={`cursor-pointer font-DMSans text-sm font-semibold ${
            isAllSelected ? 'text-black-500' : 'text-primary-600'
          } cursor-pointer`}
          onClick={() => setIsAllSelected(!isAllSelected)}
        >
          {isAllSelected ? 'Deselect All' : 'Select All'}
        </span>
      </div>

      <ActionPlanPlanCards
        adminPlans={adminPlans}
        selectedPlans={selectedPlans}
        openPlans={openPlans}
        handleCheckboxChange={handleCheckboxChange}
        togglePlan={togglePlan}
        onOpen={onOpen}
        isDesktop={isDesktop}
      />

      <ActionPlanBottomBar
        flowStep={flowStep}
        sipDate={sipDate}
        sipDates={sipDates}
        selectedDay={selectedDay}
        setSelectedDay={setSelectedDay}
        mandatesState={mandatesState}
        mandates={mandates}
        disableButtons={disableButtons}
        mandateRegistration={mandateRegistration}
        generateOTP={generateOTP}
        loading={loading}
        setMessageModalState={setMessageModalState}
        openOTPPopup={openOTPPopup}
        setOpenOTPPopup={setOpenOTPPopup}
        userDetails={userDetails}
        email={email}
        handleSipOrOT={handleSipOrOT}
      />
    </div>
  )
}

export default Plans
